import React, { useContext, useEffect, useState, Fragment } from "react";
import SignedInNavbarImproved from "../../SignedInNavbarImproved";
import { debounce } from "lodash";
import Container from "../my_container/Container";
import FeaturedCarousel from "./FeaturedCarousel";
import { Menu } from "@headlessui/react";
import ProductCarousel from "./ProductCarousel";
import toast from "react-hot-toast";
import { GoSearch } from "react-icons/go";
import { FiChevronDown } from "react-icons/fi";
import { authService } from "../../../services/authService";
import RxjsStoreContext from "../../../context/RxjsStoreContext";
import BasketService from "../../../services/basketService";
import TopDeals from "../create_basket_page/TopDeals";
import AllItems from "../create_basket_page/AllItems";
import SearchPageEmpty from "../create_basket_page/SearchPageEmpty";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchGrocedyForAll,
  fetchProductFeatureInfo,
  userAdvertsGet,
} from "../../../store/actions";
import RewardCenterAdsPopup from "../reward_center/reward_center_ads/RewardCenterAdsPopup";
import { setIsPastLogin } from "../../../store/slices/modalSlice";
import { Dialog, Transition } from "@headlessui/react";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import BasketFloatingPane from "../create_basket_page/BasketFloatingPane";

const SignedInHomeWelcome = () => {
  const rxjsStore = useContext(RxjsStoreContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openGiftModal, setOpenGiftModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [basketGroupList, setBasketGroupList] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [fetchedProducts, setFectchedProducts] = useState([]);
  const [currentSection, setCurrentSection] = useState("");
  const [allProductList, setAllProductList] = useState([]);
  const [prdId, setPrdId] = useState("");
  const [fetchedAdvertLinks, setFetchedAdvertLinks] = useState();
  const [fetchedFeatureProduct, setFetchedFeatureProduct] = useState([]);
  const searchRef = React.createRef();
  const customerId = authService.getCurrentUserCustomerId();
  const [selectedOption, setSelectedOption] = useState(null);

  const isTour = localStorage.getItem("isTour");

  const [fetchedAdsInfo, setFetchedAdsInfo] = useState([]);

  const { grocedyForAll } = useSelector((state) => state.masterData);
  const { adverts } = useSelector((state) => state.user);

  const style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 20,
    left: "auto",
    position: "fixed",
  };

  useEffect(() => {
    advertsFetcher();
  }, []);

  useEffect(() => {
    if (!grocedyForAll) {
      dispatch(fetchGrocedyForAll(customerId ? customerId : "0"))
        .unwrap()
        .catch((err) => {
          return err;
        });
    }

    if (grocedyForAll) {
      setFectchedProducts(grocedyForAll?.product_info);
    }
  }, [grocedyForAll, customerId]);

  const handleSelect = (option) => {
    setSelectedOption(option);
  };

  useEffect(() => {
    if (fetchedProducts?.length) {
      const pubId = fetchedProducts
        ?.filter((fp) => fp?.product_id === "2")
        .pop();
      setPrdId(pubId?.product_id);
    }
  }, [fetchedProducts]);

  useEffect(() => {
    dispatch(fetchProductFeatureInfo())
      .unwrap()
      .then((res) => {
        if (!res?.product_feature_info?.length) {
          setFetchedFeatureProduct([]);
        }
        setFetchedFeatureProduct(res?.product_feature_info);
      })
      .catch((err) => err);
  }, []);

  useEffect(() => {
    dispatch(setIsPastLogin(true));
  }, [dispatch]);

  useEffect(() => {
    if (adverts?.length) {
      setFetchedAdvertLinks(adverts);
    }
  }, [adverts]);

  useEffect(() => {
    if (authService.isLogin() && prdId) {
      callApiForAuth();
    }
    rxjsStore.getAllBasketProductList().subscribe((allProduct) => {
      setAllProductList(allProduct);
      setSearchResult(allProduct);
    });

    rxjsStore.getBasketGroupList().subscribe((data) => {
      if (data?.length < 1) {
        callApi();
      } else {
        setBasketGroupList(data);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prdId]);

  useEffect(() => {
    if (grocedyForAll?.ad_info?.length) {
      setFetchedAdsInfo(grocedyForAll?.ad_info);
    }
  }, [grocedyForAll]);

  const debouncedSearch = React.useRef(
    debounce(async (event) => {
      processSearch(event);
    }, 1500)
  ).current;

  function advertsFetcher() {
    try {
      dispatch(userAdvertsGet());
    } catch (err) {
      return err;
    }
  }

  function callApiForAuth() {
    setIsLoading(true);
    if (prdId) {
      BasketService.getBasketListAuth(prdId)
        .then((data, failed) => {
          if (failed) {
            // return toast.error("error getting products");
          }

          setIsLoading(false);
          const { item_group, items, delivery_charge } = data;
          if (item_group?.length) {
            rxjsStore.setBasketGroupList(item_group);
            rxjsStore.setAllBasketProductList(items);
            let charge = {
              item_id: delivery_charge[0]?.item_id,
              item_total: delivery_charge[0]?.item_rate,
              rate: delivery_charge[0]?.item_rate,
              quantity: 1,
              name: "Delivery charge",
            };
            rxjsStore.setDeliveryChargeBasket(charge);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          // toast.error("Error getting product");
        });
    }
  }

  function callApi() {
    setIsLoading(true);
    BasketService.getBasketList()
      .then((data, failed) => {
        if (failed) {
          return toast.error("error getting products");
        }

        setIsLoading(false);
        const { item_group, items, delivery_charge } = data;
        if (item_group?.length) {
          rxjsStore.setBasketGroupList(item_group);
          rxjsStore.setAllBasketProductList(items);

          let charge = {
            item_id: delivery_charge[0]?.item_id,
            item_total: delivery_charge[0]?.item_rate,
            rate: delivery_charge[0]?.item_rate,
            quantity: 1,
            name: "Delivery charge",
          };
          rxjsStore.setDeliveryChargeBasket(charge);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error("Error getting product");
      });
  }

  const resetProductGroup = (groupId) => {
    const newList = rxjsStore.getProductByGroup(groupId);
    // setAllProductList(newList);
    setCurrentSection(groupId);
    setSearchResult(newList);
  };

  function processSearch(event) {
    const search = event.target.value;
    // setSearchTextInput(search);

    setCurrentSection(search);

    if (search.length < 2) {
      setCurrentSection("");
      rxjsStore.getAllBasketProductList().subscribe((allProduct) => {
        setAllProductList(allProduct);
        setSearchResult(allProduct);
      });
      return;
    } else if (search.length > 2) {
      var tempResult = rxjsStore.handleSearchProduct(search);
      setSearchResult(tempResult);
    }
  }

  return (
    <>
      <SignedInNavbarImproved isTour={isTour} />
      <div className="bg-[#F5F5F5] pb-60">
        <Container className="pt-8">
          {fetchedAdvertLinks && fetchedAdvertLinks?.length ? (
            <div>
              <h1 className="text-xl font-bold text-gray-800">Featured</h1>
              <FeaturedCarousel fetchedAdvertLinks={fetchedAdvertLinks} />
            </div>
          ) : null}

          {fetchedFeatureProduct && fetchedFeatureProduct?.length ? (
            <div className="mt-6">
              <h2 className="text-xl font-bold text-gray-800">Buy</h2>
              <ProductCarousel setOpenGiftModal={setOpenGiftModal} fetchedFeatureProduct={fetchedFeatureProduct} />
            </div>
          ) : null}

          <div className="mt-6 rounded-2xl border-[1px] border-gray-100 bg-white px-4 py-6 shadow-md">
            <div>
              <div className="mt-6 flex items-center justify-between">
                <h2 className="text-xl font-bold text-gray-800 ">Items</h2>
                <div className="z-20">
                  <Menu>
                    <Menu.Button className="flex flex-row items-center space-x-1 text-olivine-500">
                      <p className="font-medium">Categories</p>
                      <div className="p- rounded-full p-1 transition duration-200 hover:bg-[#F0F4E7] hover:ring-[1px] hover:ring-gray-200">
                        <FiChevronDown className="h-4 w-4 cursor-pointer" />
                      </div>
                    </Menu.Button>
                    <Menu.Items className="absolute right-14 flex h-full max-h-60 w-60 origin-top-right flex-col divide-y-[1px] divide-gray-200 overflow-y-scroll rounded-lg border-[1px] border-gray-200 bg-white shadow-xl focus:outline-none">
                      {basketGroupList?.length &&
                        basketGroupList.map((category, index) => (
                          <div
                            key={index}
                            onClick={() =>
                              resetProductGroup(category?.group_id)
                            }
                            className="cursor-pointer p-1"
                          >
                            <p className="rounded-md px-3 py-2 pl-8 text-right text-sm text-gray-500 transition duration-200 hover:bg-[#F0F4E7] hover:text-olivine-500">
                              {category?.group_name}
                            </p>
                          </div>
                        ))}
                    </Menu.Items>
                  </Menu>
                </div>
              </div>
              <div className="relative z-10 mx-auto mt-4 w-full max-w-xl lg:-mt-8">
                <input
                  ref={searchRef}
                  onChange={(ev) => {
                    debouncedSearch(ev);
                    // setSearchInputValue(ev.target.value);
                  }}
                  type="text"
                  placeholder="Quick search for anything"
                  className="w-full rounded-lg border-gray-300 bg-[#F9F9F9] pl-4 pr-14 text-gray-700 outline-none ring-0 placeholder:font-normal placeholder:text-gray-400 focus:border-olivine-600 focus:outline-none focus:ring-1 focus:ring-olivine-600"
                />
                <div className="absolute bottom-0 right-0 top-0 my-[1.5px] mr-[1.5px] w-11 rounded-r-md bg-gray-200" />
                <div className="absolute right-3 top-3">
                  <GoSearch className="h-5 w-5 cursor-pointer rounded-full text-olivine-500" />
                </div>
              </div>
            </div>
            {/* <div className="mt-6 grid gap-6 grid-auto-fit-sm"> */}
            <div className="mt-6 flex flex-col">
              {/* the cards are coming here */}
              {!currentSection && (
                <>
                  <div>
                    <TopDeals allProductList={allProductList} />
                  </div>
                </>
              )}
              <div>
                {searchResult?.length ? (
                  <AllItems allProductList={searchResult} />
                ) : (
                  <SearchPageEmpty searchResult={searchResult} />
                )}
              </div>
            </div>
            {fetchedAdsInfo?.length ? (
              <RewardCenterAdsPopup adsInfo={fetchedAdsInfo} />
            ) : null}
          </div>
        </Container>
      </div>
      <div>
        <Transition appear show={openGiftModal} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50"
            onClose={() => setOpenGiftModal(false)}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black/25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-xl bg-white text-left align-middle shadow-xl transition-all">
                    <div className="scrollbar-thumb-[#1a3517] scrollbar-track-[#265426] h-full max-h-[525px] overflow-y-scroll p-2 scrollbar-thin">
                      <div
                        onClick={() =>
                          setOpenGiftModal(false)
                        }
                        className="fixed right-4 top-3 w-fit cursor-pointer rounded-full p-1.5 text-gray-700 hover:bg-gray-200 active:bg-gray-100"
                      >
                        <IoClose
                          onClick={() => {
                            window.location.reload();
                          }}
                          className="h-5 w-5"
                        />
                      </div>
                      <div className="mb-6 px-2 sm:px-6">
                        <h2 className="mt-6 text-xl font-bold text-gray-700">
                          Send a Gift
                        </h2>
                        <div>
                          <div
                            className={`mt-6 cursor-pointer p-4 rounded-xl border ${selectedOption === "plan" ? "border-blue-500 bg-blue-50" : "border-gray-200"
                              }`}
                            onClick={() => handleSelect("plan")}
                          >
                            <h3 className="text-base font-bold text-gray-600">Gift a Plan</h3>
                            <p className="text-sm text-gray-600">Shop and Gift our Curated Plans</p>
                          </div>

                          <div
                            className={`mt-4 cursor-pointer p-4 rounded-xl border ${selectedOption === "basket" ? "border-blue-500 bg-blue-50" : "border-gray-200"
                              }`}
                            onClick={() => handleSelect("basket")}
                          >
                            <h3 className="text-base font-bold text-gray-600">Gift a Customised Basket</h3>
                            <p className="text-sm text-gray-600">Shop and Gift a Customised basket</p>
                          </div>
                        </div>
                        <div className="mt-8 flex items-center justify-between">
                          <button
                            className="w-fit transform cursor-pointer rounded-md border-[1px] border-gray-300 bg-white px-10 py-3 text-sm font-semibold text-gray-600 transition-all duration-200 focus:outline-none"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => {
                              if (selectedOption === "plan") {
                                return navigate("/gift-a-plan")
                              } else if (selectedOption === "basket") {
                                return navigate("/gift-a-basket")
                              } else {
                                return;
                              }
                            }}
                            className={`w-fit transform rounded-md px-10 py-3 text-sm font-semibold text-white transition-all duration-200 focus:outline-none @sm:max-w-[180px] cursor-pointer bg-[#558223] hover:bg-olivine-500/80 active:bg-olivine-600`}
                          >
                            Proceed
                          </button>
                        </div>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>


        <section className="flex justify-center bg-red-900">
          <BasketFloatingPane style={style} />
        </section>
      </div>
    </>
  );
};

export default SignedInHomeWelcome;
